import Flash from "lib/flash"
import { currentUser } from "lib/currentUser"
import { wrapInUserModel } from "models/user"
import { getWindowLocation } from "lib/windowLocation"

export default async function initFlashNotices() {
  let params = new URLSearchParams(getWindowLocation().search)
  let message = params.get("notice")

  const user = await currentUser().then(wrapInUserModel)

  if (message && user.isEditor()) {
    Flash.now("notice", message)
  }
}
